import { toast } from "sonner";

export type FeedbackTone = "info" | "success" | "warning" | "error" | "loading";

type FeedbackId = string | number;

interface FeedbackOptions {
  description?: string;
  duration?: number;
  id?: FeedbackId;
}

function baseOptions(options?: FeedbackOptions) {
  return {
    description: options?.description,
    duration: options?.duration,
    id: options?.id,
  };
}

export function notifyInfo(message: string, options?: FeedbackOptions): FeedbackId {
  return toast.info(message, baseOptions(options));
}

export function notifySuccess(message: string, options?: FeedbackOptions): FeedbackId {
  return toast.success(message, baseOptions(options));
}

export function notifyWarning(message: string, options?: FeedbackOptions): FeedbackId {
  return toast.warning(message, baseOptions(options));
}

export function notifyError(message: string, options?: FeedbackOptions): FeedbackId {
  return toast.error(message, baseOptions(options));
}

export function notifyLoading(message: string, options?: FeedbackOptions): FeedbackId {
  return toast.loading(message, baseOptions(options));
}

export function updateFeedback(
  id: FeedbackId,
  tone: Exclude<FeedbackTone, "loading">,
  message: string,
  options?: Omit<FeedbackOptions, "id">,
): FeedbackId {
  const payload = {
    ...baseOptions(options),
    id,
  };

  if (tone === "success") return toast.success(message, payload);
  if (tone === "warning") return toast.warning(message, payload);
  if (tone === "error") return toast.error(message, payload);
  return toast.info(message, payload);
}

export function dismissFeedback(id?: FeedbackId): void {
  toast.dismiss(id);
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return fallback;
}
